import { Box, Typography } from '@mui/material';
import ReactPlayer from 'react-player';


const DocumentViewer = ({ document, purchase }: any) => {
    // Check if fileUrl is available
    // if (!document?.fileUrl) {
    //     return (
    //         <Box sx={{ color: "red", textAlign: "center", marginTop: "20px", width: "100%" }}>
    //             <Typography variant="h6">File not available</Typography>
    //         </Box>
    //     );
    // }
    return (
        <>
            {document.type === 'pdf' ? (
                <Box sx={styleSheet.pdfContainer}>
                    <iframe
                        src={document.fileUrl}
                        style={styleSheet.pdfIfram}
                        title="Document Viewer"
                    ></iframe>
                </Box>
            ) : document.type === "image" ? (
                // Render Image
                <Box
                    sx={styleSheet.imageContainer}
                >
                    <img
                        src={document?.fileUrl}
                        alt="Document"
                        style={{ maxWidth: '100%', maxHeight: "100%", objectFit: "contain" }}
                    />
                </Box>
            ) : (
                <Box sx={styleSheet.videoContainer}>
                    {/* <ReactPlayer
                        url={document.url}
                        controls
                        width='100%'
                        height='100%'
                    /> */}
                    asdasd
                </Box>

            )}
        </>
    );
}

export default DocumentViewer;


const styleSheet = {
    pdfContainer: {
        border: '1px solid #E0E0E0',
        borderRadius: '8.46px',
        overflow: 'hidden',
        flexGrow: 1,
        backgroundColor: '#f5f5f5',
        height: { xs: "497px", md: '603px' },
    },
    pdfIfram: {
        width: '100%', height: 'calc(100% - 0px)', border: 'none',

    },
    imageContainer: {
        display: "flex",
        width: '100%',
        justifyContent: "center",
        // alignItems: "center",
        backgroundColor: "#f5f5f5",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
    videoContainer: {
        borderRadius: '8.46px',
        overflow: 'hidden',
        flexGrow: 1,
        width: { xs: "378px", md: '767px' },
        height: { xs: "293.4px", md: '603px' },
    }
}